import { acceptableImageFormat } from '../../constants/FilterDataValues';
import { errorMsg } from '../../constants/messages';

const PhotomitraAdvantageFormData = [
  {
    title: 'Advantage Details',
    name: 'title',
    label: 'Title',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Title', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'details',
    label: 'Details',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Details' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'iconImage',
    label: 'Icon Image',
    fieldType: {
      name: 'photomitraFile',
      accept: acceptableImageFormat,
      maxCount: '1',
      allowImageCropping: true,
    },
    placeholder: 'Click here to select',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Icon Image',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: true,
    isAccordian: true,
  },
];

export { PhotomitraAdvantageFormData };
